import { AppRedirectionInfo, JuspayMetaDataInfo } from "@swiggy-private/payment-types";
import { isEmpty } from "@swiggy-private/js-utils";

interface JuspayMetaParams {
    authTypeForCard?: string;
    juspayClientAuthToken: string;
    juspayClientAuthTokenExpiry?: number;
    juspayMetaData?: JuspayMetaDataInfo;
    tokenRequester?: string;
    par?: string;
}

export function buildJuspayMeta(token: string, appRedirectionInfo: AppRedirectionInfo): JuspayMetaParams {
    const cardRedirect: AppRedirectionInfo["cardRedirect"] | undefined = appRedirectionInfo?.cardRedirect;

    const requiredMetadata = {
        authTypeForCard: "",
        juspayClientAuthToken: token,
    };

    const juspayInfo = cardRedirect?.tokenInfo?.juspayInfo ?? {};
    const tokenRequester = cardRedirect?.tokenRequester;

    if (!isEmpty(juspayInfo?.temporaryToken) && !isEmpty(tokenRequester)) {
        return {
            ...requiredMetadata,
            tokenRequester,
            juspayMetaData: {
                temporaryToken: juspayInfo?.temporaryToken,
                providerCategory: juspayInfo?.providerCategory,
                requesterId: juspayInfo?.requesterId,
                tokenType: juspayInfo?.tokenType,
                provider: juspayInfo?.provider,
                providerReferenceId: juspayInfo?.providerReferenceId,
            },
        };
    }

    return { ...requiredMetadata };
}
